import React from 'react';

const Loader = ({ visible }) => {
  return (
    <div className={`loader ${!visible ? 'loader--hidden' : ''}`}>
      <div className="loader__logo" style={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
        <img src="/images/final_logo.png" alt="200 OK Studios Logo" style={{ height: '80px', objectFit: 'contain' }} />
      </div>
      <div className="loader__bar">
        <div className="loader__bar-fill"></div>
      </div>
    </div>
  );
};

export default Loader;
